import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, first, map, Subscription } from 'rxjs';
import { Option } from '../../../core/models/option.model';

enum PRICE_MEDIA_TABS {
  PRICE_MEDIA_HISTORY = 'PRICE_MEDIA_HISTORY',
  PRICE_MEDIA_REQUEST = 'PRICE_MEDIA_REQUEST',
}

@Component({
  selector: 'app-price-media',
  templateUrl: './price-media.component.html',
  styleUrl: './price-media.component.scss',
  standalone: false,
})
export class PriceMediaComponent implements OnInit, OnDestroy {
  PRICE_MEDIA_TABS = PRICE_MEDIA_TABS;
  priceMediaCurrentTab?: Option = undefined;
  priceMediaTabs$ = new BehaviorSubject<Option[]>([]);
  subscription = new Subscription();

  ngOnInit(): void {
    this.getPriceMediaTabs();
    this.priceMediaTabs$
      .pipe(
        map(options => options[0]),
        first(),
      )
      .subscribe(firstOption => (this.priceMediaCurrentTab = firstOption));
  }

  getPriceMediaTabs(): void {
    this.priceMediaTabs$.next([
      { code: PRICE_MEDIA_TABS.PRICE_MEDIA_HISTORY, label: 'Request History' },
      { code: PRICE_MEDIA_TABS.PRICE_MEDIA_REQUEST, label: 'Request ' },
    ]);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
